export default "__VITE_ASSET__CONnUJ2v__"